import React, { useEffect, useState } from 'react';
import ModalContainer from 'components/molecules/ModalContainer';
import { useOrdersContext } from 'contextApi/OrdersContext';
import useStyles from '../OrderPackageList/OrderPackageList.styles';
import {
  Typography,
  Table,
  TableBody,
  Paper,
  Box,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button,
  Grid
} from '@material-ui/core';
import { IOrderPackages, IOrderProducts, IPackages } from 'interfaces/orderPackages.interface';

interface Props {
  open: boolean;
  close(): void;
  newPackSource: IPackages;
  newPackDestination: IPackages;
  productInfo: IOrderProducts;
  source: any;
  destination: any;
}
export default function MovePorduct({
  open,
  close,
  productInfo,
  newPackSource,
  newPackDestination,
  source,
  destination
}: Props) {
  const { orderPackages, setOrderPackages } = useOrdersContext();
  const styles = useStyles();
  const [quantityMoved, setQuantityMoved] = useState(productInfo.quantity);
  useEffect(() => {
    setQuantityMoved(productInfo.quantity);
    console.log('llega', quantityMoved, 'deveria', productInfo.quantity);
  }, [productInfo]);
  const move = (
    source: IOrderProducts[],
    destination: IOrderProducts[],
    droppableSource: any,
    droppableDestination: any
  ) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    if (Number(productInfo.quantity) === Number(quantityMoved)) {
      const [removed] = sourceClone.splice(droppableSource.index, 1);
      const productExist = destClone.find((product) => product.id === removed.id);
      if (productExist) {
        if (productExist.quantity) {
          productExist.quantity = productExist.quantity + Number(quantityMoved);
          productExist.quantityToSend = productExist.quantity;
        }
      } else {
        destClone.splice(droppableDestination.index, 0, removed);
      }
    } else {
      const productToMoved = sourceClone[droppableSource.index];
      const productExist = destClone.find((product) => product.id === productToMoved.id);
      if (productExist) {
        productToMoved.quantity = Number(productToMoved.quantity) - Number(quantityMoved);
        productToMoved.quantityToSend = productToMoved.quantity;
        setQuantityMoved(productToMoved.quantity);
        if (productExist.quantity) {
          productExist.quantity = productExist.quantity + Number(quantityMoved);
          productExist.quantityToSend = productExist.quantity;
        }
      } else {
        destClone.splice(droppableDestination.index, 0, {
          ...productToMoved,
          quantity: quantityMoved,
          quantityToSend: quantityMoved
        });
        productToMoved.quantity = Number(productToMoved.quantity) - Number(quantityMoved);
        productToMoved.quantityToSend = productToMoved.quantity;
        setQuantityMoved(productToMoved.quantity);
      }
    }
    const result: any = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
  };

  const onMove = (newPackSource: IPackages, newPackDestination: IPackages, orderPackages: IOrderPackages) => {
    if (
      newPackSource?.products !== undefined &&
      newPackDestination?.products !== undefined &&
      orderPackages.packages !== undefined
    ) {
      const result = move(newPackSource.products, newPackDestination.products, source, destination);

      const newPackSourceIndex = orderPackages.packages.findIndex(
        (sourceIndex: IPackages) => sourceIndex.id === Number(source.droppableId)
      );
      const newPackDestinationIndex = orderPackages.packages.findIndex(
        (destinationIndex: IPackages) => destinationIndex.id === Number(destination.droppableId)
      );

      orderPackages.packages[newPackSourceIndex].products = result[source.droppableId];
      orderPackages.packages[newPackDestinationIndex].products = result[destination.droppableId];

      const itemsD = {
        orderNumber: orderPackages.orderNumber,
        packages: orderPackages.packages
      };
      setOrderPackages(itemsD);
    }
  };

  return (
    <ModalContainer open={open} onClose={close} title="Cantidad del producto que desea mover" maxWidth="sm">
      <TableContainer component={Paper} className={styles.tableContainer}>
        <Table aria-label="collapsible table">
          <TableBody>
            <TableRow>
              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                <Box margin={1}>
                  <Typography variant="h6" gutterBottom component="div">
                    Producto
                  </Typography>
                  <Table size="small" aria-label="purchases" className={styles.tableContainer}>
                    <TableHead>
                      <TableRow>
                        <TableCell>SKU</TableCell>
                        <TableCell>Nombre</TableCell>
                        <TableCell align="right">Cantidad</TableCell>
                        <TableCell align="right">Mover</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow key={productInfo.id}>
                        <TableCell>{productInfo.sku}</TableCell>
                        <TableCell>{productInfo.name}</TableCell>
                        <TableCell align="right">{productInfo.quantity}</TableCell>
                        <TableCell align="right">
                          <TextField
                            value={quantityMoved}
                            type="number"
                            InputProps={{
                              inputProps: { max: productInfo.quantity, min: 0 }
                            }}
                            onChange={(e) => {
                              const quantityToMove = Number(e.target.value);
                              const quantity = Number(productInfo.quantity);
                              if (quantityToMove >= 0 && quantityToMove <= quantity) {
                                setQuantityMoved(Number(e.target.value));
                              }
                            }}
                          ></TextField>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Grid container justify="center" alignItems="center">
        <Button
          variant="contained"
          color="primary"
          style={{ marginTop: 20 }}
          onClick={() => {
            onMove(newPackSource, newPackDestination, orderPackages);
            close();
          }}
        >
          MOVER
        </Button>
        <Button onClick={() => close()} variant="contained" color="default" style={{ marginTop: 20, marginLeft: 10 }}>
          CANCELAR
        </Button>
      </Grid>
    </ModalContainer>
  );
}
